const StockMarketMantraList = [
    {
        title: 'Discipline is the Key',
        content: 'Maintain Discipline to Succeed in Trading'
    },
    {
        title: 'Patience Pay Off',
        content: 'Stay Patient with Winning Trades'
    },
    {
        title: 'Keep it Simple',
        content: 'Don’t Overthink or Over-complicate Your Trading Strategies'
    },
    {
        title: 'Stay Humble',
        content: 'Always remain Humble and Willing to Learn'
    },
    {
        title: 'No Setup - No Trade',
        content: 'Always Wait for the Perfect Setup Before Trading'
    }
]

export default StockMarketMantraList;